import React, { useEffect, useState } from "react";
import { LuImage, LuSearch } from "react-icons/lu";
import { fetchIdealStudioFiles } from "../../../common/server_utils.es6";
import i18n from "i18next";
import { motionSourceFromFileRow } from "./sceneVisualService";

// Hareketli Görsel'in GIF/WebP'si kütüphaneden eklenince de kalemini taşısın:
// kaynak dokümanın adresi kütüphane satırının metadata'sında.
const libraryExtra = (file) => {
  const motionSource = motionSourceFromFileRow(file.raw, file.url);
  return motionSource ? { motionSource } : undefined;
};

const LibraryImageTab = ({ onAddToScene, fileType = "image" }) => {
  const [files, setFiles] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [hoveredId, setHoveredId] = useState(null);

  useEffect(() => {
    let isCancelled = false;

    const loadFiles = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await fetchIdealStudioFiles({
          search: searchTerm || undefined,
          limit: 50,
          offset: 0,
          fileType,
        });

        if (!isCancelled && response && Array.isArray(response.files)) {
          const mapped = response.files.map((file) => ({
            id: file.id,
            name: file.fileName || file.filename || "Untitled",
            url: file.fileVirtualPath,
            raw: file,
          }));
          setFiles(mapped);
        }
      } catch (err) {
        if (!isCancelled) {
          setError(i18n.t("files_load_error") || "Dosyalar yüklenemedi");
          setFiles([]);
        }
      } finally {
        if (!isCancelled) {
          setLoading(false);
        }
      }
    };

    const timeoutId = setTimeout(loadFiles, 250);

    return () => {
      isCancelled = true;
      clearTimeout(timeoutId);
    };
  }, [searchTerm, fileType]);

  return (
    <div className="add-image-modal__library">
      <div className="add-image-modal__library-header">
        <div className="add-image-modal__library-search">
          <LuSearch className="add-image-modal__library-search-icon" />
          <input
            type="text"
            placeholder={i18n.t("search") || "Ara"}
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
          />
        </div>
      </div>

      {error && !loading && <div className="add-image-modal__library-status">{error}</div>}

      {loading && (
        <div className="add-image-modal__library-grid">
          {Array.from({ length: 8 }).map((_, index) => (
            <div
              key={index}
              className="add-image-modal__library-card add-image-modal__library-skeleton"
            >
              <div className="add-image-modal__library-thumb add-image-modal__skeleton-thumb" />
              <div className="add-image-modal__library-name add-image-modal__skeleton-name" />
            </div>
          ))}
        </div>
      )}

      {!loading && !error && (
        <div className="add-image-modal__library-grid">
          {files.map((file) => (
            <div
              key={file.id}
              className={`add-image-modal__library-card${
                selectedId === file.id ? " add-image-modal__library-card--active" : ""
              }`}
              onClick={() => setSelectedId(file.id)}
              onMouseEnter={() => setHoveredId(file.id)}
              onMouseLeave={() => setHoveredId((current) => (current === file.id ? null : current))}
              onDoubleClick={() => {
                if (onAddToScene && file.url) {
                  onAddToScene(file.url, file.name, libraryExtra(file));
                }
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 6,
                  right: 6,
                  display: "flex",
                  gap: 4,
                  zIndex: 5,
                  opacity: hoveredId === file.id ? 1 : 0,
                  pointerEvents: hoveredId === file.id ? "auto" : "none",
                  transition: "opacity 150ms ease-out",
                }}
              >
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (onAddToScene && file.url) {
                      onAddToScene(file.url, file.name, libraryExtra(file));
                    }
                  }}
                  title={i18n.t("AddToScene") || "Sahneye ekle"}
                  style={{
                    width: 26,
                    height: 26,
                    borderRadius: 999,
                    border: "1px solid #e5e7eb",
                    backgroundColor: "rgba(255,255,255,0.95)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                >
                  <svg
                    viewBox="0 0 24 24"
                    width="16"
                    height="16"
                    stroke="#4b5563"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  >
                    <rect x="4" y="4" width="16" height="16" rx="3" ry="3" />
                    <line x1="12" y1="8" x2="12" y2="16" />
                    <line x1="8" y1="12" x2="16" y2="12" />
                  </svg>
                </button>
              </div>

              <div className="add-image-modal__library-thumb">
                {file.url && fileType === "video" ? (
                  <video src={file.url} preload="metadata" muted />
                ) : file.url ? (
                  <img src={file.url} alt={file.name} />
                ) : (
                  <LuImage />
                )}
              </div>
              <div
                className="add-image-modal__library-name"
                style={{
                  fontSize: "11px",
                  color: "#9ca3af",
                  fontWeight: 400,
                }}
                title={file.name}
              >
                {file.name}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LibraryImageTab;
